import React from "react";
import logos from "../images/logos2.png";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-red">
      <div className="container d-flex justify-content-center">
        <a
          className="navbar-brand"
          href="http://www.cultura.unam.mx/index.aspx"
        >
          <img src={logos} alt="" />
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
